/* eslint-disable max-len */
import { IconButton, Select, Tooltip, MenuItem, Typography, Divider, CircularProgress, Box } from '@mui/material';
import { useEffect, useState } from 'react';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import * as Yup from 'yup';
import { GridColDef } from '@mui/x-data-grid';
import PersonIcon from '@mui/icons-material/Person';
import { Link } from 'react-router-dom';
import DialogAction from '../components/Dialog/DialogAction';
import moment from 'moment';
import { RequestDict } from '../components/dictionaries/RequestStatus';
import TableGridWithFilters from '../components/TablegridWithFilters/TableGridWithFilters/TableGridWithFilters';
import Theme from '../Themes/main.theme';
import { Status } from '../components/dictionaries/Request';
import HttpService from '../services/HttpService';
import { getAllUsers } from '../lib/static/users/fetchers';
import PageviewOutlinedIcon from '@mui/icons-material/PageviewOutlined';
import { useNavigate } from 'react-router-dom';
import UserService from '../services/UserService';
import { AdminAssignApplicationPermissions, MassivePermissions, Permissions } from '../lib/permissions';
import MultiStatusSelector from '../components/EnableComponent/MultiStatusSelector';
import { createFilterModel, downloadExcel, eliminateOjectNotTruthyValues } from '../lib/helperFuncs';
import AsyncButton from '../components/AsyncButton/AsyncButton';
import { findRestApplications, mapPermissionScopeToString, matchTitlesToPermissions, matchTitlesToPermissionsEach, matchUnitsToPermissions } from '../components/form_v2/helpers';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useUserDbInfo } from '../hooks/UserInfo';

interface ISubmit {
  id: number | undefined;
  responsible_user_id?: number | undefined | null;
  category?: string | undefined | null;
}

const initialValues = {
  protocol_number: '',
  title: '',
  responsible_user_id: '',
  status: '',
  section_id: '',
  administrative_unit: '',
};


function EligibleApplicationsToView({ titles }: { titles: { key: string; value: number }[] }) {
  // if () {
  //   return;
  // }

  return <div>

    {UserService.hasRole([MassivePermissions.PermissionInternalApplicationsSubmissionsMassiveAll]) && <div>
      Βάση των δικαιωμάτων σας, έχετε πρόσβαση σε <u>όλα τα αιτήματα του ΕΚΟΜΕ</u>, όλων των οργανικών μονάδων.
    </div>
    }


    {UserService.hasRole([MassivePermissions.PermissionInternalApplicationsSubmissionsMassiveMyOrg]) && !UserService.hasRole([MassivePermissions.PermissionInternalApplicationsSubmissionsMassiveMyOrg]) && <div>
      Βάση των δικαιωμάτων σας, έχετε πρόσβαση σε <u>όλα τα αιτήματα του ΕΚΟΜΕ</u>, της οργανικής μονάδας στην οποία ανήκετε.
    </div>}
    <br />


    <div>
      Βάση των δικαιωμάτων σας, τα <u>κύρια</u> αιτήματα που έχετε πρόσβαση είναι:
      <ul>
        {
          matchTitlesToPermissionsEach()
            .map((title: any) =>
              <li key={title.applicationTitle}>
                <u>{titles.find(x => x.value == title.applicationTitle)?.key}</u>
                <b> ({mapPermissionScopeToString(title.applicationScope)}) </b>
              </li>
            )
        }
        <br />
        <br />
      </ul>
    </div>

    Βάση των δικαιωμάτων σας, τα <u>υπόλοιπα</u> αιτήματα που έχετε πρόσβαση είναι:
    <br />
    <br />

    <ul>
      {
        findRestApplications(titles).map((title: any) =>
          <li key={title.applicationTitle}>
            <u>{titles.find(x => x.value == title.applicationTitle)?.key}</u>
            <b> ({mapPermissionScopeToString(title.applicationScope)}) </b>
          </li>
        )
      }
    </ul>

  </div >;
}


const shouldDisplayChangeUserAssignee = (row: any, userDbInfo: any) => {
  if (![
    'professionals',
    'location',
    'filming',
  ].includes(row.category))
    return false;

  if (row.category == 'professionals') {

    if (UserService.hasRole([AdminAssignApplicationPermissions.PermissionsInternalAssignProfessionalAll])) {
      return true;
    }

    if (UserService.hasRole([AdminAssignApplicationPermissions.PermissionsInternalAssignProfessionalMyOrg]) && row.administrative_unit_id == userDbInfo.administrative_unit_id) {
      return true;
    }
    return false;
  }

  if (row.category == 'location') {

    if (UserService.hasRole([AdminAssignApplicationPermissions.PermissionsInternalAssignLocationAll])) {
      return true;
    }

    if (UserService.hasRole([AdminAssignApplicationPermissions.PermissionsInternalAssignLocationMyOrg]) && row.administrative_unit_id == userDbInfo.administrative_unit_id) {
      return true;
    }
    return false;
  }

  return false;

};

const ApplicationsDashboard = () => {
  const [loadingUsers, setLoadingUsers] = useState<boolean>(false);
  const [isLoadingExcel, setIsLoadingExcel] = useState<boolean>(false);
  const [open, setOpen] = useState(false);
  const { loading: userInfoLoading, userDbInfo } = useUserDbInfo();
  const [idSelected, setIdSelected] = useState<any>();
  const [administrativeUnits, setAdministrativeUnits] =
    useState<{ key: string; value: number }[]>([]);
  const [reFetch, setReFetch] = useState(false);
  const [statuses, setsStatuses] = useState<{ key: string; value: number }[]>([]);
  const [titles, setTitles] = useState<{ key: string; value: number }[]>([]);
  const [newUser, setNewUser] = useState<number | undefined | null>();
  const [filters, setFilters] = useState<any>();
  const [data, setData] = useState<any>([]);
  const [users, setUsers] =
    useState<{ key: string | null; value: number | null | undefined | string }[]>([]);
  const navigate = useNavigate();

  const getAllUnitUsersAndOmekaPublishers = async (administrative_unit_id: number | undefined | null) => {
    setLoadingUsers(true);
    try {
      const respUnit: any = await getAllUsers({
        administrative_unit_id: administrative_unit_id,
        is_enabled: true
      });
      const respPublishers: any = await getAllUsers({
        'urm.role_id': 'f4bbf0e8-fe6b-472e-908e-515c53bc1602', // this is about EKOME publishers
        is_enabled: true
      });

      const resp = {
        data: [...respUnit.data.map((x:any) => {
          return {
            ...x,
            full_name: `${x?.full_name} (Οργανική Μονάδα)`
          };
        }),
        ...respPublishers.data.map((x:any) => {
          return {
            ...x,
            full_name: `${x?.full_name} (Publisher)`
          };
        }),
        ],
        total_count: respUnit?.total_count + respPublishers?.total_count
      };

      setUsers(resp.data.map((user: any) => {
        return {
          key: user.full_name,
          value: user.id
        };
      }));
    } catch (error) {
      console.error(error);
    }
    setLoadingUsers(false);
  };

  const columns: GridColDef[] = [
    {
      field: 'title',
      headerName: 'Τίτλος Αιτήματος',
      minWidth: 260
    },
    {
      field: 'responsible_user',
      headerName: 'Υπεύθυνος Χειριστής',
      minWidth: 200,
      renderCell: (params) => params.row.full_name
        ? <Link to={`/admin/users/${params.row.responsible_user_id}`}>{params.row.full_name}</Link>
        : '-'
    },
    {
      field: 'administrative_unit',
      headerName: 'Αρμόδια Οργανική Μονάδα',
      minWidth: 250,
      renderCell: (params) => params.row.category
        ? <Link to={params.row.category === 'professionals'
          ? `/admin/units/${params.row.office}/${params.row.professional_administrative_unit_id}`
          : `/admin/units/${params.row.office}/${params.row.administrative_unit_id}`}
        >
          {params.row.category === 'professionals'
            ? params.row.professional_administrative_unit
            : params.row.administrative_unit}
        </Link>
        : '-'
    },
    {
      field: 'submit_date',
      headerName: 'Ημερομηνία Υποβολής',
      minWidth: 195,
      renderCell: (params) => params.row.submit_date
        ? moment(params.row.submit_date).format('DD/MM/YYYY, HH:mm:ss').toLocaleString() //'default', {hour12: false }
        : null
    },
    {
      field: 'status',
      headerName: 'Κατάσταση Αιτήματος',
      minWidth: 198,
      renderCell: ({ row }) => <>
        <MultiStatusSelector status={RequestDict[row.status]}
          labelStatus={RequestDict[row.status]} />
      </>
    },
    {
      field: 'action',
      headerName: 'Ενέργειες',
      minWidth: 105,
      sortable: false,
      renderCell:
        (params) =>
          <>
            <Tooltip PopperProps={{
              disablePortal: true
            }}
            title='Προβολή'>
              <IconButton
                color='primary'
                disabled={
                  !UserService.hasRole([
                    Permissions.PermissionInternalLocationApplicationCreateMy_org
                  ])
                }
                onClick={() =>
                  navigate(params.row.category === 'professionals'
                    ? `/admin/professionals/view/${params.row.id}`
                    : params.row.category === 'location'
                      ? `/admin/applications/view/${params.row.id}`
                      : params.row.category === 'filming'
                        ? `/admin/applications/view-interest/${params.row.id}`
                        : `/admin/applications/details/${params.row.id}`)
                }>
                <PageviewOutlinedIcon />
              </IconButton>
            </Tooltip>
            <Tooltip
              PopperProps={{
                disablePortal: true
              }}
              title={'Αλλαγή Χρήστη'}>
              <>
                {!userInfoLoading
                  ? shouldDisplayChangeUserAssignee(params.row, userDbInfo)
                    ? <IconButton color='primary'
                      disabled={Status.Success === params.row.status ||
                        Status.Rejected === params.row.status}
                      onClick={() => {
                        getAllUnitUsersAndOmekaPublishers(params.row.office_id);
                        setOpen(true);
                        setIdSelected({ id: params.row.id, category: params.row.category });
                      }}>
                      {!params.row.resposible_user_id
                        ? <PersonIcon />
                        : <PersonOutlineOutlinedIcon />
                      }
                    </IconButton>
                    : <div></div>
                  : <CircularProgress size='24' />}
              </>

            </Tooltip>
          </>
    }
  ];

  const filterFields = [
    [{
      control: 'input',
      type: 'number',
      customLabel: true,
      name: 'protocol_number',
      label: 'Αριθμός Πρωτοκόλλου',
      require: true,
      filtersDesign: true,
    },
    {
      control: 'autocomplete',
      type: 'autocomplete',
      label: 'Τίτλος Αιτήματος',
      name: 'title',
      filtersDesign: true,
      options: titles,
    },
    {
      control: 'autocomplete',
      type: 'autocomplete',
      label: 'Υπεύθυνος Χειριστής',
      name: 'responsible_user_id',
      filtersDesign: true,
      options: users
    }],
    [{
      control: 'autocomplete',
      type: 'autocomplete',
      label: 'Κατάσταση Αιτήματος',
      name: 'status',
      filtersDesign: true,
      options: statuses
    },
    {
      control: 'autocomplete',
      type: 'autocomplete',
      label: 'Αρμόδια Οργανική Μονάδα',
      name: 'administrative_unit_id',
      filtersDesign: true,
      options: administrativeUnits
    }]

  ];

  const SubmitValue = async ({ responsible_user_id, id, category }: ISubmit) => {
    try {
      const _category = category === 'location'
        ? 'locations'
        : category === 'professionals' && 'professionals';
      await HttpService.getAxiosClient().put(`${process.env.REACT_APP_BACKEND_URL}/applications/${_category}/${id}`, {
        responsible_user_id: responsible_user_id
      });
      setReFetch(!reFetch);
    } catch (error) {
      console.error(error);
    }

  };

  const validationSchema = Yup.object({
    protocol_number: Yup
      .number()
      .typeError('Πρέπει να συμπληρώσετε αριθμό')
      .nullable(true),
  });


  const getStatuses = async () => {
    const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/users-parametrics/status`);
    setsStatuses(
      response.data.status
        .sort((a: any, b: any) => a.key.localeCompare(b.key, 'el'))
        .filter((x: any) => x.value !== 1)
    );
  };


  const getAdminUnits = async () => {
    const response =
      matchUnitsToPermissions() || UserService.hasRole([MassivePermissions.PermissionInternalApplicationsSubmissionsMassiveAll])
        ? await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/users-parametrics/administrative_unit`)
        : await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/users-parametrics/administrative_unit/my_org`);
    setAdministrativeUnits(response.data.units.sort((a: any, b: any) => a.key.localeCompare(b.key, 'el')));
  };


  const getTitles = async () => {
    const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/users-parametrics/titles`, {
      params: {
        ids: MassivePermissions.PermissionInternalApplicationsSubmissionsMassiveAll || MassivePermissions.PermissionInternalApplicationsSubmissionsMassiveMyOrg || Permissions.PermissionInternalRestApplicationsReadAll || Permissions.PermissionInternalRestApplicationsReadMy_org
          ? null
          : matchTitlesToPermissions()
      }
    });
    setTitles(response.data.titles.sort((a: any, b: any) => a.key.localeCompare(b.key, 'el')));
  };

  const getUsers = async () => {
    const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/users?role=internal`);
    const _users = response.data.data.map((user: any) => {
      return {
        key: user.full_name,
        value: user.id
      };
    });
    setUsers(_users.sort((a: any, b: any) => a.key.localeCompare(b.key, 'el')));
  };

  const downloadApplications = async () => {
    setIsLoadingExcel(true);
    try {
      const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/applications/locations/download`, {
        responseType: 'blob',
        params: eliminateOjectNotTruthyValues({
          ...filters,
          drafts: false
        })
      });
      downloadExcel(response, 'Λίστα Αιτημάτων');
    } catch (error) {
      console.error(error);
    }
    setIsLoadingExcel(false);
  };


  useEffect(() => {
    getStatuses();
    getAdminUnits();
    getUsers();
    getTitles();
  }, []);

  return (
    <>
      <Typography variant='h2' sx={{ my: 2, mt: 4 }}
        color={Theme.labelColor?.main}>
        Συγκεντρωτικός Πίνακας Αιτημάτων
      </Typography>
      <Divider sx={{ mb: 5, border: 1, color: Theme?.dividerColor?.main }} />

      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel1a-content'
          id='panel1a-header'
        >
          <Typography>Ποια αιτήματα μπορώ να δω;</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <EligibleApplicationsToView titles={titles} />
          </Typography>
        </AccordionDetails>

      </Accordion>

      <TableGridWithFilters
        {...((filters && Object.keys(filters).length > 0 && data.length > 0) && {
          componentInBetween: <Box mt={2}
            display='flex'
            justifyContent='end'
          >
            <AsyncButton title='Λήψη Excel'
              isLoading={isLoadingExcel}
              onClick={downloadApplications} />
          </Box>
        })}
        onFetch={
          (data) => setData(data.data)
        }
        onFiltersChange={
          (filters) => setFilters(eliminateOjectNotTruthyValues(createFilterModel(filters)))
        }
        reFetch={reFetch}
        responseDataFieldName='data'
        responseTotalCountFieldName='total_count'
        sortModel={[{ field: 'submit_date', sort: 'desc' }]}
        pageSize={15}
        rowsPerPageOptions={[15, 30, 45]}
        sortingMode='server'
        paginationMode='server'
        initialValues={initialValues}
        filterFields={filterFields}
        validationSchema={validationSchema}
        columns={columns}
        fetchUrl={`${process.env.REACT_APP_BACKEND_URL}/applications/locations/offices?drafts=false`}
        resetFilters={true} />
      <DialogAction
        open={open} title={'Αλλαγή Ανάθεσης σε'}
        handleClose={() => {
          setOpen(false);
          setNewUser(undefined);
        }}
        content={
          loadingUsers
            ? <Box display='flex' justifyContent='center'>
              <CircularProgress />
            </Box>
            : users.length === 0
              ? 'Δεν υπάρχουν διαθέσιμοι Ενεργοί Χρήστες στην συγκεκριμένη Οργανική Μονάδα'
              : <Select
                MenuProps={{
                  disablePortal: true
                }}
                fullWidth
                value={newUser}
                onChange={(e) => setNewUser(e.target.value as number)}
              >
                {users.map((option) => {
                  return (
                    <MenuItem key={option.value} value={option.value as any}>{option.key}</MenuItem>
                  );
                })}
              </Select>
        }
        onAccept={() => {
          SubmitValue({
            responsible_user_id: newUser, id: idSelected?.id, category: idSelected.category
          });
          setOpen(false);
        }}
      />
    </>
  );
};

export default ApplicationsDashboard;